import React from 'react';
import ListView from './ListView';
export default function Entitlements(){
  return <ListView icon="entitlements" title="Entitlements" subtitle="Which skills, packages, suites, or overlays a workspace or customer can use." path="/entitlements" columns={["id","scope","workspace_id","customer_id","kind","ref_id","included_credits"]} mapRow={r=>r} />;
}
